import { parseAsUTC } from 'src/app/helpers';
import { CustomRoute, ItemStatus, PointType, TransferIconNameMap } from '../interfaces/custom-route.interface';
import { DailyRouteResponse, RecommendedRouteResponse } from "../interfaces/custom-route.response";

export const customRouteAdapter = (
  id: number,
  dailyRoutes: DailyRouteResponse[],
  recommended_route?: RecommendedRouteResponse,
  enableGoogleMaps: boolean = false
): CustomRoute => {
  return {
    id: id,
    dailyRoutes: dailyRoutes.map(dailyRoute => ({
      id: dailyRoute.id,
      date: dailyRoute.date ? parseAsUTC(dailyRoute.date) : new Date(),
      weatherIconName: dailyRoute.weather ? dailyRoute.weather.iconName : null,
      startPoint: {
        lat: dailyRoute.startPoint.lat,
        lng: dailyRoute.startPoint.lng,
        address: dailyRoute.startPoint.address
      },
      endPoint: dailyRoute.endPoint ? {
        lat: dailyRoute.endPoint.lat,
        lng: dailyRoute.endPoint.lng,
        address: dailyRoute.endPoint.address
      } : undefined,
      endPolylinePath: dailyRoute.endPolylinePath?.map(location => ({
        lat: location.lat,
        lng: location.lng,
      })),
      points: dailyRoute.points.map(point => ({
        id: point.id,
        type: point.type as PointType,
        category: point.category?.length
          ? {
              id: point.category[0].id,
              nameSlug: point.category[0].nameSlug,
              name: point.category[0].name
            }
          : undefined,
        img: point.img,
        category_image: point.category_image,
        status: ItemStatus.PENDING,
        title: point.title,
        startDate: point.startDate ? parseAsUTC(point.startDate) : new Date(),
        endDate: point.endDate ? parseAsUTC(point.endDate) : new Date(),
        duration: point.duration,
        opening_hours: point.opening_hours,
        previousLocation: {
          lat: point.previousLocation.lat,
          lng: point.previousLocation.lng,
          address: point.previousLocation.address
        },
        currentLocation: {
          lat: point.currentLocation.lat,
          lng: point.currentLocation.lng,
          address: point.currentLocation.address
        },
        polylinesPath: point.polylinesPath?.map(location => ({
          lat: location.lat,
          lng: location.lng,
        })),
        totalTransferDistance: point.totalTransferDistance,
        totalTransferDuration: point.totalTransferDuration,
        transfers: point.transfers?.map(transfer => ({
          instruction: transfer.instruction,
          distance: transfer.distance,
          duration: transfer.duration,
          location: {
            lat: transfer.location.lat,
            lng: transfer.location.lng,
          },
          mode: transfer.mode,
          iconName: transfer.icon ?? TransferIconNameMap.walk
        })),
        transportList: point.transportList?.map(transport => ({
          id: transport.id,
          name: transport.name,
          stopDetails: transport.instruction,
          duration: Math.round(transport.duration) ?? 1, // duration in minutes, minimum 1 minute
          iconName: transport.iconName ?? TransferIconNameMap.walk
        })) ?? null,
        nextPoint: point.nextPoint,
        isValid: point.isValid,
        validationIssues: point.validationIssues ?? [],
        is_saturated: point.is_saturated,
        saturation_label: point.saturation_label,
        labels: point.labels,
        tags: point.tags,
        badges: point.badges
      }))
    })),
    recommended_route: recommended_route,
    config: {
      enableGoogleMaps
    }
  }
};
